import React from 'react'
import { Text, TitleWrapper, TitleText, OptionText } from '@/style-guide'
import { Divider } from 'antd'

export const AttendeesDetails = ({ guests, user }) => {
  return guests && guests.length > 0 ? (
    <>
      <Divider />
      <TitleWrapper>
        <TitleText>Additional guest information</TitleText>
        {guests.map((guest, index) => (
          <OptionText key={'guest' + index}>
            {guest.name && (
              <div>
                <Text size={14}>
                  Guest name:
                  {(guest.name || (guest.firstName || guest.lastName) || guest.email) && (
                    <span style={{ float: 'right' }}>
                      {guest.name || 
                      (guest.firstName || guest.lastName ? `${guest.firstName || ''} ${guest.lastName || ''}`.trim() : '') || 
                      guest.email}
                    </span>
                  )}
                </Text>
              </div>
            )}
            {guest.relationship && (
              <div>
                <Text size={14}>
                  Relationship with {user && user.firstName}:
                  <span style={{ float: 'right' }}>{guest.relationship}</span>
                </Text>
              </div>
            )}
          </OptionText>
        ))}
      </TitleWrapper>
    </>
  ) : null
}
